import { DatePicker, Form } from 'antd';
import dayjs from 'dayjs';
import { FC } from 'react';

import { READABLE_DATE_FORMAT } from 'consts';
import { useIntl } from 'hooks';

import * as duck from './duck';

const InputDatePicker: FC<duck.Types.InputDatePickerProps> = ({
  label,
  name,
  allowClear = false,
  required = false,
  rules = [],
  isAfterToday,
}) => {
  const intl = useIntl();

  return (
    <Form.Item
      name={name}
      label={
        label &&
        intl.formatMessage({
          id: label,
          defaultMessage: '',
        })
      }
      getValueProps={(value) => ({
        value: value && dayjs(value),
      })}
      rules={[
        {
          required,
          message: intl.formatMessage({
            id: 'validation.required',
          }),
        },
        {
          validator: (rule, value) => {
            if (!value || !isAfterToday) {
              return Promise.resolve();
            }

            if (dayjs(value).valueOf() > dayjs().valueOf()) {
              return Promise.reject(
                intl.formatMessage({
                  id: 'validation.futureDate',
                }),
              );
            }

            return Promise.resolve();
          },
        },
        ...rules,
      ]}
    >
      <DatePicker
        placeholder={READABLE_DATE_FORMAT}
        style={{ width: '100%' }}
        format={READABLE_DATE_FORMAT}
        allowClear={allowClear}
      />
    </Form.Item>
  );
};
export default InputDatePicker;
